import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";

// import * as mutationTypes from '../mutation-types';

const state = () => ({
    loaders: {
        gltf: new GLTFLoader(),
      },
});

const getters = {
    meshIsAccessory: () => (mesh) => {
        if(mesh.type == 'Mesh')
            return mesh.material.name.includes('ACC_') || mesh.name.includes('ACC_');
        else
            return false
    },
    accessoriesOf: () => (model) => {
        const meshes = [];
    
        // console.log(model);
        function mapMesh(...array) {
    
          if(array.length) {
            array.map((child) => {
    
              if(child.type == 'Mesh') {
    
                if(child.material.name.includes('ACC_') || child.name.includes('ACC_'))
                  meshes.push(child);
    
              } else {
                mapMesh(...child.children);
              }
            })
          }
        }
    
        if(model) {
          mapMesh(model);
        }    
    
        return meshes;
      },
      meshesOf: () => (model) => {
        const meshes = [];
    
        // console.log(model);
        function mapMesh(...array) {
    
          if(array.length) {
            array.map((child) => {
    
              if(child.type == 'Mesh') {
    
                meshes.push(child);
    
              } else {
                mapMesh(...child.children);
              }
            })
          }
        }
    
        if(model) {
          mapMesh(model);
        }    
    
        return meshes;
      },
};

const mutations = {

};

const actions = {
    dispose: ({getters, dispatch},payload) => {

        const meshes = getters['meshesOf'](payload);
        meshes.forEach(mesh => {
            dispatch('fabrics/disposeMaterial',mesh.material,{root:true});
            mesh.geometry.dispose(true);
            mesh = null;
        });
    
      },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  }